import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from 'redux/actions/index';

const Home = () => {
   return (
      <div id="wrap">
         <section className="ihWeb_sec theme_nav_mt">
            <div className="container">
               <div className="row">
                  <div className="col-sm-12 mx-auto">
                     <div className="ihWeb_bgSh">
                        <article className="ihWeb_art text-center">
                           <h2>
                              Thank You for Connecting with us!! <br />
                              Our App is Available on Both:
                           </h2>
                        </article>
                        <ul className="ihWeb_2clm">
                           <li style={{ cursor: 'pointer' }}>
                              <div className="fig_wrpShp">
                                 <a target="_blank" href="https://apps.apple.com/us/app/inharmony-music-meditations/id1532172047"><figure className="ihWeb_fig">
                                    <img
                                       src={require('assets/images/icon/apple.png')}
                                       alt="iOS User"
                                    />
                                 </figure>
                                    <h3>
                                       <a
                                          rel="noopener noreferrer"
                                          className="text_decoration"
                                       >
                                          iOS User
                                    </a>
                                    </h3>
                                 </a>
                              </div>
                           </li>
                           <li style={{ cursor: 'pointer' }}>
                              <div className="fig_wrpShp">
                                 <a href="https://play.google.com/store/apps/details?id=com.inharmony.app" target="_blank">
                                    <figure className="ihWeb_fig">
                                       <img
                                          src={require('assets/images/icon/android.png')}
                                          alt="Android User"
                                       />
                                    </figure>
                                    <h3>
                                       <a
                                          rel="noopener noreferrer"
                                          className="text_decoration"
                                       >
                                          Android User
                                    </a>
                                    </h3>
                                 </a>
                              </div>
                           </li>
                        </ul>
                        <h4 className="text-center text-white">
                           *Use Same Credentials for login
                        </h4>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section class="para_sec">
            <div class="container">
               <div class="row">
                  <div class="col-sm-12">
                     <article class="ihWeb_art text-center ihWeb_bgSh_art site_heading">
                        <h2 class="text_tertiary">
                           How it Works<br /> Technology to Optimize Your Meditation:
                </h2>
                        <div class="tech_para">
                           <p>
                              Combining Meditation, Frequency, Vibration & Technology to Optimize Human Potential. Step into the world of sound and frequency assisted meditation and mindfulness. Let's get inHarmony with the world around us. The benefits of being inHarmony are broad and comprehensive. Take control and make an impact on your:
                  </p>
                           <p>
                              Focus & mental clarity<br />
                    Anxiety & Stress<br />
                    Sleep & mood<br />
                    Muscle tension & chronic ailments
                  </p>
                           <p>
                              #TogetherWeCan. Join our growing community of incredible humans on a quest to improve our overall health and well being. inHarmony Interactive brings together years of science and research in sound, frequency, vibration, meditation, breath work, mindfulness, optimal human performance, rejuvenation and longevity. Within our app, you will discover beautiful sound experienced designed to take your mind and body to new heights. We're excited to have you with us. We're excited for you to contribute to our community. Grow with us. See you soon.
                  </p>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </section >
      </div >
   );
};

export default Home;
